"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _ContentWrapper = _interopRequireDefault(require("./components/ContentWrapper"));

var _useTheme = _interopRequireDefault(require("../hooks/useTheme"));

var _useStateWithTimeout5 = _interopRequireDefault(require("../hooks/useStateWithTimeout"));

var _consts = require("./consts");

var _handleKeyDown = _interopRequireDefault(require("../utils/handleKeyDown"));

var useRef = React.useRef,
    useCallback = React.useCallback,
    useMemo = React.useMemo,
    useEffect = React.useEffect;

var StyledPopoverChild = _styledComponents.default.div.withConfig({
  displayName: "Popover__StyledPopoverChild",
  componentId: "t88fx4-0"
})(["position:relative;"]);

var Popover = function Popover(_ref) {
  var children = _ref.children,
      content = _ref.content,
      _ref$preferredPositio = _ref.preferredPosition,
      preferredPosition = _ref$preferredPositio === void 0 ? _consts.POSITIONS.BOTTOM : _ref$preferredPositio,
      _ref$preferredAlign = _ref.preferredAlign,
      preferredAlign = _ref$preferredAlign === void 0 ? _consts.ALIGNS.START : _ref$preferredAlign,
      dataTest = _ref.dataTest,
      opened = _ref.opened,
      width = _ref.width,
      noPadding = _ref.noPadding,
      overlapped = _ref.overlapped,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      fixed = _ref.fixed,
      actions = _ref.actions;
  var theme = (0, _useTheme.default)();
  var transitionLength = useMemo(function () {
    return parseFloat(theme.orbit.durationFast) * 1000;
  }, [theme.orbit.durationFast]);

  var _useStateWithTimeout = (0, _useStateWithTimeout5.default)(false, transitionLength),
      _useStateWithTimeout2 = (0, _slicedToArray2.default)(_useStateWithTimeout, 4),
      shown = _useStateWithTimeout2[0],
      setShown = _useStateWithTimeout2[1],
      setShownWithTimeout = _useStateWithTimeout2[2],
      clearShownTimeout = _useStateWithTimeout2[3];

  var _useStateWithTimeout3 = (0, _useStateWithTimeout5.default)(false, transitionLength),
      _useStateWithTimeout4 = (0, _slicedToArray2.default)(_useStateWithTimeout3, 4),
      render = _useStateWithTimeout4[0],
      setRender = _useStateWithTimeout4[1],
      setRenderWithTimeout = _useStateWithTimeout4[2],
      clearRenderTimeout = _useStateWithTimeout4[3];

  var container = useRef(null);
  var resolveCallback = useCallback(function (state) {
    if (onClose && !state) onClose();
    if (onOpen && state) onOpen();
  }, [onClose, onOpen]);
  var handleOut = useCallback(function (ev) {
    // If open prop is present ignore custom handler
    if (container.current && !container.current.contains(ev.target)) {
      if (typeof opened === "undefined") {
        setShown(false);
        clearShownTimeout();
        setRenderWithTimeout(false);
        resolveCallback(false);
      } else if (onClose) onClose();
    }
  }, [clearShownTimeout, onClose, opened, resolveCallback, setRenderWithTimeout, setShown]);
  var handleClick = useCallback(function () {
    // If open prop is present ignore custom handler
    if (typeof opened === "undefined") {
      if (shown) {
        setShown(false);
        clearShownTimeout();
        setRenderWithTimeout(false);
        resolveCallback(false);
      } else {
        setRender(true);
        clearRenderTimeout();
        setShownWithTimeout(true);
        resolveCallback(true);
      }
    } else if (opened) {
      resolveCallback(false);
    } else if (!opened) {
      resolveCallback(true);
    }
  }, [clearRenderTimeout, clearShownTimeout, opened, resolveCallback, setRender, setRenderWithTimeout, setShown, setShownWithTimeout, shown]);
  useEffect(function () {
    if (typeof opened !== "undefined") {
      if (opened) {
        setRender(true);
        clearRenderTimeout();
        setShownWithTimeout(true);
      } else {
        setShown(false);
        clearShownTimeout();
        setRenderWithTimeout(false);
      }
    }
  }, [opened, clearRenderTimeout, clearShownTimeout, setRender, setShown, setShownWithTimeout, setRenderWithTimeout]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledPopoverChild, {
    onClick: handleClick,
    onKeyDown: (0, _handleKeyDown.default)(handleClick),
    ref: container
  }, children), render && /*#__PURE__*/React.createElement(_Portal.default, {
    renderInto: "popovers"
  }, /*#__PURE__*/React.createElement(_ContentWrapper.default, {
    shown: shown,
    width: width,
    containerRef: container,
    preferredPosition: preferredPosition,
    preferredAlign: preferredAlign,
    onClose: handleOut,
    dataTest: dataTest,
    noPadding: noPadding,
    overlapped: overlapped,
    fixed: fixed,
    actions: actions
  }, content)));
};

var _default = Popover;
exports.default = _default;